import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Main from './views/Main.vue'
//import Table from './views/nav2/Table.vue'
import store_in from './views/nav2/store_in.vue'
import store_out from './views/nav2/store_out.vue'
import store_query from './views/nav2/store_query.vue'
import remark_query from './views/nav2/remark_query.vue'
import expire_remind from './views/nav2/expire_remind.vue'
import service_provider from './views/nav3/service_provider.vue'
import company_group from './views/nav3/company_group.vue'
//import user_info from './views/nav1/user_info.vue'
//import pwd_edit from './views/nav1/pwd_edit.vue'
//import user from './views/nav1/user.vue'
//import Page4 from './views/nav2/Page4.vue'
//import Page5 from './views/nav2/Page5.vue'
//import Page6 from './views/nav3/Page6.vue'
//import echarts from './views/charts/echarts.vue'
import set_update from './views/nav3/set_update.vue'
import money_query from './views/nav2/money_query.vue'
import query_recharge from './views/nav2/query_recharge.vue'
import tao_can from './views/nav2/tao_can.vue'
import recharge_summary from './views/nav2/recharge_summary.vue'
import batch_export from './views/nav2/batch_export.vue'
import batch_back from './views/nav2/batch_back.vue'
import sendsms from './views/nav3/sendsms.vue'
import sendsms_hebei from './views/nav3/sendsms_hebei.vue'
import groupsms from './views/nav3/groupsms.vue'
//import cmcc_querysms from './views/nav3/cmcc_querysms.vue'
import noshowbalance from './views/nav3/noshowbalance.vue'
import batchimp_edit_packcode from './views/batchedit/imp_edit_pkg.vue'
import batchimp_edit_card from './views/batchedit/imp_edit_card.vue'
import price_import from './views/nav2/price_import.vue'
import traffic_warning from './views/nav2/traffic_warning.vue'
import card_batch_del from './views/batchedit/card_batch_del.vue'
import imp_charge_delay from './views/batchedit/imp_charge_delay.vue'
import batch_recharge from './views/batchedit/batch_recharge.vue'
import imp_edit_card_apicode from './views/batchedit/imp_edit_card_apicode.vue'
import bathsuspendCard from './views/batchedit/bathsuspendCard.vue'
import bathdataupdate from './views/batchedit/bathdataupdate.vue'
import bathtocharging from './views/batchedit/bathtocharging.vue'
import discountKind from './views/discountMgr/discountKind.vue'
import discountChange from './views/discountMgr/discountChange.vue'
import discountCard from './views/discountMgr/discountCard.vue'
import noticeManager from './views/nav3/noticeManager.vue'
import bathDataSyn from './views/batchedit/bathDataSyn.vue'
import bathUntying from './views/batchedit/bathUntying.vue'
import rechargeCard from './views/paycenter/rechargeCard.vue'
import set_rolemenu from './views/nav3/set_rolemenu.vue'
import bathStarting from './views/batchedit/bathStarting.vue'
import batch_flow from './views/nav2/batch_flow.vue'
import datastopcard from './views/nav3/datastopcard.vue'
import batch_addgprssize from './views/nav2/batch_addgprssize.vue'
import flowPool from './views/nav3/flow_pool.vue'
import flowReportForm from './views/nav3/flow_reportform.vue'
import maincardlist from './views/nav3/maincardlist.vue'



let routes = [{
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: '主页',
        iconCls: 'el-icon-s-home',
        children: [
            { path: '/main', component: Main, name: '信息面板' },
            { path: '/datastopcard', component: datastopcard, name: '数据达量停机' },
            { path: '/maincardlist/:state', component: maincardlist, name: '主页卡列表' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '卡号管理',
        iconCls: 'el-icon-bank-card',
        role: ['0', '1', '2'],
        children: [
            { path: '/store_in', component: store_in, name: '入库管理', role: ['0', '1'] },
            { path: '/store_out', component: store_out, name: '出库管理', role: ['0', '1'] },
            { path: '/store_query', component: store_query, name: '查询管理', role: ['0', '1', '2'] },
            { path: '/remark_query', component: remark_query, name: '备注查询', role: ['0', '1', '2'] }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '折扣管理',
        iconCls: 'el-icon-discount',
        role: ['0'],
        children: [
            { path: '/discountCard', component: discountCard, name: '折扣查询', role: ['0'] },
            { path: '/discountKind', component: discountKind, name: '折扣类型', role: ['0'] },
            { path: '/discountChange', component: discountChange, name: '折扣变更', role: ['0'] }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '批量管理',
        iconCls: 'el-icon-s-grid',
        role: ['0', '1'],
        children: [
            { path: '/batchimp_edit_packcode', component: batchimp_edit_packcode, name: '修改套餐', role: ['0'] },
            { path: '/batchimp_edit_card', component: batchimp_edit_card, name: '修改备注', role: ['0'] },
            { path: '/price_import', component: price_import, name: '充值价格', role: ['0', '1'] },
            { path: '/batch_export', component: batch_export, name: '批量导出', role: ['0', '1', '2'] },
            { path: '/card_batch_del', component: card_batch_del, name: '批量删除', role: ['0'] },
            { path: '/imp_charge_delay', component: imp_charge_delay, name: '续费延期', role: ['0'] },
            { path: '/imp_edit_card_apicode', component: imp_edit_card_apicode, name: '集团归属', role: ['0'] },
            { path: '/bathDataSyn', component: bathDataSyn, name: '批量数据同步', role: ['0'] },
            { path: '/bathUntying', component: bathUntying, name: '批量解绑', role: ['0'] },
            { path: '/batch_back', component: batch_back, name: '批量回库', role: ['0', '1'] },
            { path: '/batch_flow', component: batch_flow, name: '批量调整阀值', role: ['0'] },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '短信管理',
        iconCls: 'el-icon-chat-dot-round',
        children: [
            { path: '/sendsms_hebei', component: sendsms_hebei, name: '新短信发送' },
            { path: '/sendsms', component: sendsms, name: '短信发送' },
            { path: '/groupsms', component: groupsms, name: '短信群发' },
            //{ path: '/cmcc_querysms', component: cmcc_querysms, name: '移动短信' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '电信物联',
        iconCls: 'el-icon-monitor',
        role: ['0']
    },
    {
        path: '/',
        component: Home,
        name: '充值管理',
        iconCls: 'el-icon-money',
        role: ['0', '1', '2'],
        children: [
            { path: '/money_query', component: money_query, name: '充值记录', role: ['0', '1', '2'] },
            { path: '/rechargeCard', component: rechargeCard, name: '单卡充值', role: ['0', '1', '2'] },
            { path: '/batch_recharge', component: batch_recharge, name: '批量充值', role: ['0', '1', '2'] },
            { path: '/query_recharge', component: query_recharge, name: '订单查询', role: ['0', '1', '2'] },
            { path: '/recharge_summary', component: recharge_summary, name: '充值报表', role: ['0', '1', '2'] },
            { path: '/batch_addgprssize', component: batch_addgprssize, name: '充叠加包', role: ['0', '1', '2'] }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '风险控制',
        iconCls: 'el-icon-warning',
        role: ['0', '1', '2'],
        children: [
            { path: '/expire_remind', component: expire_remind, name: '到期提醒', role: ['0', '1', '2'] },
            { path: '/traffic_warning', component: traffic_warning, name: '流量预警', role: ['0', '1', '2'] },
            { path: '/bathsuspendCard', component: bathsuspendCard, name: '批量停复机', role: ['0'] },
            { path: '/bathdataupdate', component: bathdataupdate, name: '批量数据开关', role: ['0', '1'] },
            { path: '/bathtocharging', component: bathtocharging, name: '批量转为计费期', role: ['0', '1'] },
            { path: '/bathStarting', component: bathStarting, name: '机卡分离解绑', role: ['0', '1'] }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '系统管理',
        iconCls: 'el-icon-setting',
        role: ['0', '1'],
        children: [
            { path: '/tao_can', component: tao_can, name: '卡套餐管理', role: ['0'] },
            { path: '/service_provider', component: service_provider, name: '服务商管理', role: ['0', '1'] },
            { path: '/apiconfig', component: company_group, name: 'API配置管理', role: ['0'] },
            { path: '/set_update', component: set_update, name: '自动更新配置', role: ['0'] },
            { path: '/noshowbalance', component: noshowbalance, name: '余额屏蔽', role: ['0'] },
            { path: '/notice', component: noticeManager, name: '公告发布', role: ['0'] },
            { path: '/set_rolemenu', component: set_rolemenu, name: '角色管理', role: ['0'] },
            { path: '/flowPool', component: flowPool, name: '流量池管理', role: ['0'] },
            { path: '/flowReportForm', component: flowReportForm, name: '流量池报表', role: ['0', '1'] }

        ]
    },
    {
        path: '/',
        component: Home,
        name: '流量池管理',
        iconCls: 'el-icon-data-board',
        role: ['0', '1'],
        children: [
            { path: '/flowPool', component: flowPool, name: '流量池管理', role: ['0'] },
            { path: '/flowReportForm', component: flowReportForm, name: '流量池报表', role: ['0', '1'] }

        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js